// Refactored codeActions.js with secureFetch
import { BASE_URL } from '../../constants';
import { secureFetch } from '../../utils/secureFetch';

// CodeOptions Actions
export const fetchCodeOptions = () => async (dispatch, getState) => {
  try {
    const data = await secureFetch({ method: 'GET', url: `${BASE_URL}/api/users/codeoptions/`, getState });
    dispatch({ type: 'FETCH_CODEOPTIONS', payload: data });
  } catch (err) {
    console.error('fetchCodeOptions error:', err);
  }
};

export const createCodeOption = (option) => async (dispatch, getState) => {
  try {
    const data = await secureFetch({ method: 'POST', url: `${BASE_URL}/api/users/codeoptions/`, body: option, getState });
    dispatch({ type: 'CREATE_CODEOPTION', payload: data });
  } catch (err) {
    console.error('createCodeOption error:', err);
  }
};

export const updateCodeOption = (option) => async (dispatch, getState) => {
  try {
    const data = await secureFetch({ method: 'PUT', url: `${BASE_URL}/api/users/codeoptions/${option._id}/`, body: option, getState });
    dispatch({ type: 'UPDATE_CODEOPTION', payload: data });
  } catch (err) {
    console.error('updateCodeOption error:', err);
  }
};

export const deleteCodeOption = (option) => async (dispatch, getState) => {
  try {
    await secureFetch({ method: 'DELETE', url: `${BASE_URL}/api/users/codeoptions/${option._id}/`, getState });
    dispatch({ type: 'DELETE_CODEOPTION', payload: option._id });
  } catch (err) {
    console.error('deleteCodeOption error:', err);
  }/* The commented out code `// case 'FETCH_ALL_SCHOOL_TEAMS':` and the following lines are defining
  a case in the codeReducer function for handling the action type 'FETCH_ALL_SCHOOL_TEAMS'. When
  this action type is dispatched, it would update the state by replacing the `allSchoolTeams`
  property with the payload provided in the action. */
  
};

// Codes Actions
export const fetchAllCodes = () => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_URL}/api/users/codes/all/`);
    const data = await res.json();
    dispatch({ type: 'FETCH_ALL_CODES', payload: data });
  } catch (err) {
    console.error('fetchAllCodes error:', err);
  }
};

export const fetchCodes = (codeOptionID) => async (dispatch, getState) => {
  try {
    const data = await secureFetch({ method: 'GET', url: `${BASE_URL}/api/users/codes/${codeOptionID}/`, getState });
    dispatch({ type: 'FETCH_CODES', payload: data });
  } catch (err) {
    console.error('fetchCodes error:', err);
  }
};

export const createCode = (code) => async (dispatch, getState) => {
  try {
    const data = await secureFetch({ method: 'POST', url: `${BASE_URL}/api/users/codes/`, body: code, getState });
    dispatch({ type: 'CREATE_CODE', payload: data });
  } catch (err) {
    console.error('createCode error:', err);
  }
};

export const updateCode = (code) => async (dispatch, getState) => {
  try {
    const data = await secureFetch({ method: 'PUT', url: `${BASE_URL}/api/users/codes/${code._id}/`, body: code, getState });
    dispatch({ type: 'UPDATE_CODE', payload: data });
  } catch (err) {
    console.error('updateCode error:', err);
  }
};

export const deleteCode = (code) => async (dispatch, getState) => {
  try {
    await secureFetch({ method: 'DELETE', url: `${BASE_URL}/api/users/codes/${code._id}/`, getState });
    dispatch({ type: 'DELETE_CODE', payload: code._id });
  } catch (err) {
    console.error('deleteCode error:', err);
  }
};

// export const fetchAllSchoolTeams = () => async (dispatch) => {
//   try {
//     const res = await fetch(`${BASE_URL}/api/users/sportradar/schools-teams/`);
//     const data = await res.json();
//     dispatch({ type: 'FETCH_ALL_SCHOOL_TEAMS', payload: data });
//   } catch (err) {
//     console.error('fetchAllSchoolTeams error:', err);
//   }
// };